import React from "react";
import { Link } from "react-router-dom";
import { Heart, Phone, Mail, MapPin, Facebook, Instagram } from "lucide-react";
import { useLocation } from "react-router-dom";

const Footer: React.FC = () => {
  const location = useLocation();

  if (
    location.pathname.startsWith("/dashboard") &&
    !location.pathname.startsWith("/dashboard/login")
  ) {
    return <footer></footer>;
  } else {
    return (
      <footer className="bg-gray-900 text-white">
        <div className="container mx-auto px-4 py-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Company Info */}
            <div className="col-span-1 lg:col-span-2">
              <div className="flex items-center space-x-2 mb-1">
                <Heart className="h-8 w-8 text-blue-400" />
                <span className="text-2xl font-bold">Almond Tree</span>
              </div>
              <p className="text-gray-300 mb-2 max-w-md">
                Providing exceptional assisted living care with compassion,
                dignity, and respect. Your loved ones deserve the very best, and
                we're here to deliver it.
              </p>
              <div className="flex space-x-4">
                <a
                  href="https://www.facebook.com/profile.php?id=61551894864782"
                  target="_blank"
                  className="text-gray-300 hover:text-blue-400 transition-colors"
                >
                  <Facebook className="h-6 w-6" />
                </a>
                <a
                  href="https://www.instagram.com/almondtreeseniorcare/"
                  target="_blank"
                  className="text-gray-300 hover:text-blue-400 transition-colors"
                >
                  <Instagram className="h-6 w-6" />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-lg font-semibold mb-1">Quick Links</h3>
              <ul className="space-y-2">
                <li>
                  <Link
                    to="/dashboard"
                    className="text-gray-300 hover:text-blue-400 transition-colors"
                  >
                    Employee Login
                  </Link>
                </li>
                <li></li>
                <li>
                  <Link
                    to="/about#about"
                    className="text-gray-300 hover:text-blue-400 transition-colors"
                  >
                    About Us
                  </Link>
                </li>
                <li>
                  <Link
                    to="/services#services"
                    className="text-gray-300 hover:text-blue-400 transition-colors"
                  >
                    Our Services
                  </Link>
                </li>
                <li>
                  <Link
                    to="/facilities"
                    className="text-gray-300 hover:text-blue-400 transition-colors"
                  >
                    Facilities
                  </Link>
                </li>
                <li>
                  <Link
                    to="/#testimonials"
                    className="text-gray-300 hover:text-blue-400 transition-colors"
                  >
                    Testimonials
                  </Link>
                </li>
                <li>
                  <Link
                    to="/contact#contact"
                    className="text-gray-300 hover:text-blue-400 transition-colors"
                  >
                    Contact Us
                  </Link>
                </li>
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h3 className="text-lg font-semibold mb-1">Contact Info</h3>
              <ul className="space-y-3">
                <li className="flex items-center space-x-2">
                  <Phone className="h-5 w-5 text-blue-400" />
                  <span className="text-gray-300">(720) 999-7773</span>
                </li>
                <li className="flex items-center space-x-2">
                  <Mail className="h-5 w-5 text-blue-400" />
                  <span className="text-gray-300">
                    info@almondtreeseniorcare.com
                  </span>
                </li>
                <li className="flex items-start space-x-2">
                  <MapPin className="h-5 w-5 text-blue-400 mt-1" />
                  <span className="text-gray-300">
                    Multiple Locations
                    <br />
                    Serving Your Community
                  </span>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-gray-800 mt-3 pt-8 text-center">
            <p className="text-gray-400">
              © 2025 Almond Tree Assisted Living. All rights reserved. |
              <span className="hover:text-blue-400 cursor-pointer">
                {" "}
                <Link
                  to="/privacypolicy.html"
                  target="_blank"
                  className="text-gray-300 hover:text-blue-400 transition-colors"
                >
                  Privacy Policy
                </Link>
              </span>{" "}
              |
              <span className="hover:text-blue-400 cursor-pointer">
                {" "}
                <Link
                  to="/termsofservice.html"
                  target="_blank"
                  className="text-gray-300 hover:text-blue-400 transition-colors"
                >
                  Terms of Service
                </Link>
              </span>
            </p>
          </div>
          {/* Hosted By Aajyaan */}
          <div className="border-t border-gray-800 mt-1 pt-2 text-center">
            <p className="text-gray-400">
              Hosted By
              <span className="hover:text-blue-400 cursor-pointer">
                {" "}
                <Link
                  to="https://www.aajyaan.com/"
                  target="_blank"
                  className="text-gray-300 hover:text-blue-400 transition-colors"
                >
                  Aajyaan
                </Link>
              </span>
            </p>
          </div>
        </div>
      </footer>
    );
  }
};

export default Footer;
